export class URLParamsReader {
  constructor() {
    this.urlParams = new URLSearchParams(window.location.search);
  }

  get(paramName, defaultValue = '') {
    return this.urlParams.get(paramName) || defaultValue;
  }

  has(paramName) {
    return this.urlParams.has(paramName);
  }

  getMultiple(paramNames) {
    const params = {};
    paramNames.forEach(name => {
      params[name] = this.get(name);
    });
    return params;
  }

  remove(paramName, reload = true) {
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.delete(paramName);
    
    if (reload) {
      window.location.assign(currentUrl);
    } else {
      window.history.replaceState({}, '', currentUrl);
    }
  }

  getUTMParams() {
    return this.getMultiple([
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_content',
      'utm_term',
    ]);
  }
}

export const getURLParam = (paramName, defaultValue = '') => {
  return new URLSearchParams(window.location.search).get(paramName) || defaultValue;
};

export const urlParams = new URLParamsReader();